module.exports = __webpack_public_path__ + "img/person_search_opsz20.2a6420c2.svg";